<div class="fale-conosco-container">
    <div class="text-contato">
        <div>
            <h1>Fale conosco</h1>
            <p>Entre em contato conosco para dúvidas, sugestões <br> ou suporte técnico.</p>
        </div>

        <div>
            <div class="text-contato-item">
                <div>
                    <img src="../../../assets/phone.svg" />
                </div>
                <div>
                    <small>+(55) 11 91758-5411</small>
                </div>
            </div>
            <div class="text-contato-item">
                <div>
                    <img src="../../../assets/email.svg" />

                </div>
                <div>
                    <small>suporte&#64;forecast.com</small>
                </div>
            </div>
            <div class="text-contato-item">
                <div>
                    <img src="../../../assets/pin.svg" />

                </div>
                <div>
                    <small>Rua das Obras, 465
                        São Paulo, SP - 01503-000</small>
                </div>
            </div>
        </div>

        <div class="media">
            <a>
                <img src="../../../assets/instagram.svg" />
            </a>
            <a>
                <img src="../../../assets/twitter.svg" />
            </a>
        </div>
    </div>

    <div class="form-contato">
        @if(sendSuccessfull() == null)
        {
            <form [formGroup]="form" (ngSubmit)="sendEmail()">
                <div>
                    <label>Nome</label>
                    <input formControlName="nome">
                    <app-mensagem-erro-form [formMessage]="form.get('nome')" />
                </div>
                <div>
                    <label>Email</label>
                    <input formControlName="email">
                    <app-mensagem-erro-form [formMessage]="form.get('email')" />
                </div>
                <div>
                    <label>Mensagem</label>
                    <textarea formControlName="mensagem"></textarea>
                    <app-mensagem-erro-form [formMessage]="form.get('mensagem')" />
                </div>
                <button [disabled]="isLoading()">
                    @if(isLoading())
                    {
                        <ng-container>
                            <span class="loader"></span> Aguarde...
                        </ng-container>
                    }
                    @else{
                        <ng-container>
                            Enviar
                        </ng-container>
                    }
                </button>
            </form>
        }

        @if(sendSuccessfull() == true)
        {
            <p>Email enviado com sucesso</p>
        }
        
        @if(sendSuccessfull() == false)
        {
            <p>Não foi possível enviar seu e-mail, tente novamente</p>
            <button (click)="tryAgain()">Tentar novamente</button>
        }
    </div>
</div>